
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.144","height":"22.81"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 21127","d":"M24.303 16.184h-1.089v-.485a2.4 2.4 0 00-.247-.994 1.851 1.851 0 00-1.783-1.035h-7.757v-1.6h5.956a3.58 3.58 0 003.576-3.576 3.583 3.583 0 00-3.284-3.565A6.392 6.392 0 0013.461.001 6.377 6.377 0 007.61 3.835h-.38a4.122 4.122 0 00-4.117 4.118A4.122 4.122 0 007.23 12.07h5.423v1.6h-7.71a1.851 1.851 0 00-1.783 1.035 2.4 2.4 0 00-.246.994v.432H1.845a1.843 1.843 0 00-1.841 1.841v2.944a1.843 1.843 0 001.841 1.841h2.944a1.843 1.843 0 001.841-1.841v-2.944a1.843 1.843 0 00-1.841-1.841h-1.1v-.43a1.211 1.211 0 011.256-1.259h7.71v1.689H11.6a1.843 1.843 0 00-1.84 1.841v2.944a1.843 1.843 0 001.84 1.841h2.945a1.843 1.843 0 001.841-1.841v-2.944a1.843 1.843 0 00-1.841-1.841h-1.117v-1.689h7.757a1.211 1.211 0 011.257 1.256v.485h-1.083a1.843 1.843 0 00-1.84 1.841v2.941a1.842 1.842 0 001.84 1.84h2.945a1.842 1.842 0 001.841-1.84v-2.94a1.843 1.843 0 00-1.842-1.841zM4.661 7.952A2.574 2.574 0 017.232 5.38h.91a.774.774 0 00.734-.527 4.832 4.832 0 014.587-3.306 4.842 4.842 0 014.8 4.238.773.773 0 00.768.678h.356a2.033 2.033 0 012.03 2.031 2.032 2.032 0 01-2.03 2.03H7.235a2.573 2.573 0 01-2.574-2.572zm.419 10.02v2.944a.3.3 0 01-.295.295h-2.94a.3.3 0 01-.295-.295v-2.944a.3.3 0 01.295-.295h2.944a.3.3 0 01.291.295zm9.759 0v2.944a.3.3 0 01-.295.295h-2.945a.294.294 0 01-.294-.295v-2.944a.294.294 0 01.294-.295h2.945a.3.3 0 01.295.295zm9.759 3a.3.3 0 01-.295.294h-2.945a.294.294 0 01-.294-.294v-2.947a.294.294 0 01.294-.295h2.945a.3.3 0 01.295.295z","fill":"#156ba7"}})])
          )
        }
      }
    